<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsManagement'
});
</script>
<template>
  <ka-container
    code="prog-13-management"
    :data="page.$info.prog13Management">
    <!-- Container de page formation -->
    <ka-container code="container-de-page-formation">
      <PFormationEntete
        instance-class="pf-page-formation-entete--p65"
        h-1="Formation en management "
        texte="La formation est réalisée par un<strong> expert en management</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog13Management.containerDePageFormation.containerExperts.titre.value', `Nos experts en management`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog13Management.containerDePageFormation.containerExperts.texte.value', `Lors de la construction de votre équipe ou la croissance de celle-ci, le management est la clé d’une collaboration réussie. Dans la communauté Matchers nous avons de nombreux profils experts en management, responsables de pôle commercial ayant recruté, constitué et formé des équipes, managé des ressources humaines devenus de véritables coachs ou encore des profils ayant eu de hautes responsabilités nécessitant le savoir-faire pour gérer les conflits internes. Cette pluralité de profils nous permet de vous proposer l’expert idéal pour votre projet ! Après l’avoir rencontré et validé, il vous constituera un parcours de formation sur-mesure pour vous faire monter en compétences là où vous en avez vraiment besoin !`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p65"
            :options="{
              href: `https://www.matchers.fr/expert/246`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Consultante et formatrice en management"
            first-name="Faustine"
            enttreprise="&#64;William Reed Ltd"
            image="https://ucarecdn.com/2a374138-b619-4ce1-bf14-193200662abd/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p65"
            :options="{
              href: `https://www.matchers.fr/expert/639`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :tags="page.$constants.element1Tags"
            :poste="page.$constants.element1Poste"
            first-name="Inès"
            image="https://ucarecdn.com/df180e2f-50d7-420c-b239-c1a88fbf617d/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p65"
            :options="{ hidden: true }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element2Tags" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p65"
            :options="{ hidden: true }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element3Tags" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog13Management.containerDePageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog13Management.containerDePageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Module1 -->
            <ka-container code="module-1">
              <ka-text code="adopter-une-position">
                <h2 v-html="t('prog13Management.containerDePageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.module1.adopterUnePosition.value', `Adopter une position managériale de leader `)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p65"
                  titre="I.   Développer son leadership"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-4--p65"
                  titre="II.   Communiquer efficacement sur les projets"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
            </ka-container>
            <!-- Module2 -->
            <ka-container code="module-2">
              <ka-text code="optimiser-la-collaboration">
                <h2 v-html="t('prog13Management.containerDePageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.module2.optimiserLaCollaboration.value', `Optimiser la collaboration avec son équipe`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-3" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="container-4">
              <!-- Conteneur section -->
              <ka-container code="container-5">
                <DropDownFormation
                  instance-class="element-5--p65"
                  titre="I.   Savoir susciter l'intérêt de ses collaborateurs "
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-6">
                <DropDownFormation
                  instance-class="element-6--p65"
                  titre="II.   Gérer des situations complexes"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p65" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p65"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p65" />
      <PFormationMatching
        instance-class="p-formation-matching--p65"
        :description-company="page.$constants.pFormationMatchingDescriptionCompany"
        expert-text="<strong>Faustine </strong>| Responsable d'Equipe Production Numérique | &#64;William Reed Ltd<br> <br> <br> <br><strong>Expertise : </strong>Près de 15 ans d'expérience dans le développement, le coaching et la motivation des équipes.  "
        budget-available="4 900 €"
        training-hours="35h"
        photo-expert="https://ucarecdn.com/5e549076-6d8b-470f-b380-322d17eff317/"
        image="https://ucarecdn.com/9c20500f-8b0d-448a-96d9-5ea0d00d7014/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p65" />
      <PFormationCriteresQualiopi instance-class="pf-criteres-qualiopi--p65" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsManagement } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p65')
const appData = appDataStore()
const page = formationsManagement()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
